import { Injectable } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { BaseService } from './base-service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class PythonService extends BaseService {
  backendUrl: string = environment.backendPythonFlaskUrl;
  constructor(private httpClient: HttpClient) {
    super();
  }
  hello(): Observable<Record<string, unknown>> {
    return this.httpClient.get<Record<string, unknown>>(this.backendUrl + 'hello');
  }
  notificar(titulo: string, texto: string): Observable<{ mensaje: string }> {
    return this.httpClient.post<{ mensaje: string }>(this.backendUrl + 'notificacion', { titulo, texto });
  }
  readonly helloResource = httpResource.text(() => ({

    url: this.backendUrl + 'hello',
    method: 'GET'
  }));
}
